import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "../addTeamMember/AddTeamMember.css";
import API_URL from "../../apiConfig";
import UserProfileBox from "../userProfileBox/UserProfileBox"; // Adjust the import path
import { TeamMembersService } from "../../services/teamMembers/teamMembersService";
import Loader from "../../components/common/Loader/Loader";
import { useToast } from "../../components/common/ToastManager/ToastContext";
import TopBar from "../../components/TopBar/TopBar";

const EditTeamMember = () => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const member = location.state?.member;

  const [firstName, setFirstName] = useState(member?.firstName || "");
  const [lastName, setLastName] = useState(member?.lastName || "");
  const [loginEmail, setLoginEmail] = useState(member?.email || "");
  const [phone, setPhone] = useState(member?.phone || "");
  const [dob, setDob] = useState(member?.dob || "");
  const [position, setPosition] = useState(member?.position || "");
  const [userId, setUserId] = useState(member?.userId || "");
  const [adminUserId, setAdminUserId] = useState(member?.adminUserId || "");
  const [isLoading, setIsLoading] = useState(false);

  // Map position to display value
  const getDisplayPosition = () => {
    if (position === "Reporting Manager") {
      return "Content Workflow Manager";
    } else if (position === "Admin") {
      return "AI Workforce Sponsor";
    }
    return position;
  };

  const handleCancel = () => {
    navigate("/team");
  };

  const handleUpdateMember = async () => {
    const updatedData = {
      first_name: firstName,
      last_name: lastName,
      login_email: loginEmail,
      phone: phone,
      DOB: dob,
      Position: position,
      user_id: userId, // include ID to identify which user to update
      admin_user_id: adminUserId,
    };

    try {
      setIsLoading(true);

      const response = await TeamMembersService.updateTeamMember(updatedData);

      if (response.status !== 200)
        throw new Error(`HTTP error! status: ${response.status}`);
      const result = response.data;
      showToast("Team member updated successfully!", "success");
      setIsLoading(false);
      navigate("/team");
    } catch (error) {
      showToast("Failed to update team member. Please try again.", "error");
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loader inline />;

  return (
    <div className="dashboard-container">
    <TopBar />
      <div className="add-member-wrapper">
        <button className="back-link" onClick={handleCancel}>
          <img src="/images/editarrow.svg" alt="Back" className="back-icon" />
          <span>Back To My Team</span>
        </button>

        <h2 className="add-member-title">Edit Team Member</h2>
        <div className="add-member-form-card">
          <div className="upload-photo-section">
            <div className="photo-circle">
              <img
                className="profile-image"
                src="/images/Profile.svg"
                alt="Upload"
              />
            </div>
          </div>

          <form className="form-grid">
            <div className="form-group">
              <label>
                First Name<span className="required"> *</span>
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>
                Last Name<span className="required"> *</span>
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>
                Email Id<span className="required"> *</span>
              </label>
              <input
                type="email"
                value={loginEmail}
                onChange={(e) => setLoginEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Role</label>
              <input
                type="text"
                disabled={true}
                value={getDisplayPosition()}
              />
            </div>
          </form>

          <div className="form-buttons">
            <button className="cancel-button" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="submit-button"
              type="button"
              onClick={handleUpdateMember}
            >
              Update Member
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTeamMember;
